<template>
  <nav>
    <my-icon @click="$router.push('/')">
      <img style="height: 100px;" src="/api/static/icons/cocktail (20231105111207).png">
      <!-- <img style="height: 100px;" src="/api/icons/cocktail (20231105111207).png" alt=""> -->
    </my-icon>
    <div style="margin-left: auto; font-size: 75px;" @click="$router.push('/bar')">Bar</div>
    <div class="btns" style="margin-left: auto;">
      <slot></slot>
    </div>
  </nav>
  <!-- <router-link to="/">Bar</router-link> -->
</template>


<script>
export default {}
</script>


<style>
nav {
  display: flex;
  padding: 10px;
  align-items: center;
}
nav a {
  font-weight: bold;
  color: var(--bar-color-main);
}
nav a.router-link-exact-active {
  color: #42b983;
}

.btns {
  display: flex;
}
</style>
